import surveyBgImage from '../../../assets/images/k8-g3-survey-slide.jpg'

import { default as baseTheme } from './generic'

const fonts = {
  h1: {
    fontFamily: 'gopher, sans-serif',
    fontSize: '3.5rem',
    lineHeight: '4rem',
    fontStyle: 'normal',
    letterSpacing: '.03em',
  },
  h2: {
    fontFamily: 'Short Stack, cursive',
    fontWeight: '400',
    fontSize: '2.5rem',
    lineHeight: '3.6rem',
  },
  p: {
    fontFamily: 'filson-soft, sans-serif',
    fontSize: '2.05rem',
    lineHeight: '3.3125rem',
    fontWeight: '300',
    marginBottom: '0px',
    marginTop: '0px',
  },
  li: {
    fontFamily: 'filson-soft, sans-serif',
    fontSize: '2.05rem',
    lineHeight: '3.3125rem',
    fontWeight: '300',
    marginBottom: '0px',
    marginTop: '0px',
  },
  generic: {
    fontFamily: 'filson-soft, sans-serif',
    fontSize: '2.05rem',
    lineHeight: '3.3125rem',
    fontWeight: '300',
    marginBottom: '0px',
    marginTop: '0px',
  },
  h3: {
    fontFamily: 'gopher, sans-serif',
    fontStyle: 'normal',
    margin: '0',
    fontSize: '2.7rem',
    paddingBottom: '1.0625rem',
    letterSpacing: '0.02em',
    wordSpacing: '0.16em',
    lineHeight: '1.5em',
  },
  h4: {},
  h5: {},
  h6: {},
}

export default {
  fonts: {
    ...baseTheme.fonts,
    ...fonts,
  },
  backgrounds: {
    surveySlideImage: surveyBgImage,
    surverySlideForeground: 'rgb(190, 226, 147)',
  },
}
